/* eslint-disable max-depth */
/* eslint-disable array-callback-return */
import { ActionRuleParams } from '../../types';
import { hasKitchenReferenceRule } from '../../helpers';

export const fridge24TrimKit = (params: ActionRuleParams): void => {
	// console.log('rule:func:-> fridge24TrimKit', params);
	const { refMap } = params;
	const { panelItemGroups, panelItemGroup } = refMap;
	const runRule = hasKitchenReferenceRule({ refMap, rule: 'Fridge24TrimKit' });
	if (runRule) {
		const eligibleItems = panelItemGroups.children.map((group) => group.items.children.filter((item) => item.item.component.rules.action.includes('Fridge24TrimKit')))
			.filter((group) => group.length > 0);
		const fridgeSupportPromos = refMap.kitchen.itemizedMsrp.items.filter((item) => item.sku === 'CBIR24TK');
		console.log('24" trim kit deleted', eligibleItems.length > fridgeSupportPromos.length, eligibleItems.length, '>', fridgeSupportPromos.length);
		let newTrim = null;
		if (eligibleItems.length > fridgeSupportPromos.length) {
			newTrim = panelItemGroup.items.newFromSku('CBIR24TK');
			eligibleItems.forEach((item) => {
				if (item) {
					item.forEach((i) => {
						console.log('trim added to', i);
						// i.sidePadding = 2;
					});
				}
			});
			const existingItemCenters = panelItemGroups.children
				.flatMap((group) => group.items.children)
				.map((item) => item.center);

			if (!existingItemCenters.includes(newTrim.center)) {
				panelItemGroup.items.delete(newTrim.id);
				newTrim = null;
			}
		} else {
			panelItemGroup.items.children.forEach((item) => {
				if (item.item.sku === 'CBIR24TK') {
					panelItemGroup.items.delete(item.id);
				}
			});
		}
	}
};
